module.exports = __webpack_public_path__ + "static/olusegun-11cded6cd8dfb85905ee46989e09761c.png";